module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/prize-gold-11e41438162f131ab7be8c206f77e332.svg&quot;;"